import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'orangtua'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const orangtuaCreate = 'Kepegawaian/OrangTua/create/'
export const orangtuaList = 'Kepegawaian/OrangTua/list/'
export const orangtuaDetail = 'Kepegawaian/OrangTua/detail/'
export const orangtuaUpdate = 'Kepegawaian/OrangTua/update/'
export const orangtuaInactive = 'Kepegawaian/OrangTua/inactive/'
export const orangtuaActive = 'Kepegawaian/OrangTua/active/'
export const orangtuaListPilihan = 'Kepegawaian/OrangTua/list_pilihan/'
export const orangtuaApprove = 'Kepegawaian/OrangTua/approve/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}